import React from 'react';
import parse from 'html-react-parser';

export default function TwoOptionCard({ 
    candidates, 
    used, 
    askForVote 
}) {
  if (!candidates || candidates.length < 2) return <div></div>;

  const candidate1 = candidates[0];
  const candidate2 = candidates[1];

  return (
    <div className={"box2"} key={candidate1.IDCandidato}>
      <div>
        <div className="name">{candidate1.campana}</div>
        <div className="exception-div">
          {used}
          {parse(candidate1.Descripcion)}
        </div>
        <center>
          <button 
            disabled={candidate1.estado === "Allow" ? (used === false ? "" : "disabled") : "disabled"} 
            className={(candidate1.Nombre === "No" ? "no-botton button-candidate " : "") +
                       (candidate1.estado === "Allow" ? (used === false ? "button-candidate" : "button-candidate-disabled") : "button-candidate-disabled")} 
            onClick={e => askForVote(candidate1.IDCandidato, candidate1.Nombre, e)} 
            id={candidate1.IDCandidato}
          >
            {candidate1.Nombre}
          </button>
          
          <button 
            disabled={candidate1.estado === "Allow" ? (used === false ? "" : "disabled") : "disabled"} 
            className={candidate1.estado === "Allow" ? (used === false ? "button-candidate" : "button-candidate-disabled") : "button-candidate-disabled"} 
            onClick={e => askForVote(candidate2.IDCandidato, candidate2.Nombre, e)} 
            id={candidate2.IDCandidato}
          >
            {candidate2.Nombre}
          </button>
        </center>
      </div>
    </div>
  );
}
